import * as Sentry from '@sentry/nextjs';
import Contentful from 'contentful';
import { GetServerSideProps } from 'next';

import { AboutPageContent } from '../../components/pages/about';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';
import { getContentfulClient } from '../../utils/getContentfulClient';

export type TeamMemberData = {
  name: string;
  position: string;
  imageUrl: string;
  isEmployee: boolean;
  image: Contentful.Asset;
};

export type TeamMembers = Contentful.EntryCollection<TeamMemberData>;

type Props = {
  teamMembers: TeamMembers;
};

export const getServerSideProps: GetServerSideProps = async (): Promise<{ props: Props }> => {
  try {
    const client = getContentfulClient();
    const teamMembers = await client.getEntries<TeamMemberData>({
      content_type: 'teamMembers',
      order: 'fields.order',
    });
    return {
      props: {
        teamMembers,
      },
    };
  } catch (e) {
    Sentry.captureException('Error occurred whilst fetching Team Members data from contentful', {
      extra: { reason: e },
    });
  }
};

const About: React.FC = ({ teamMembers }: Props) => {
  usePageVistTracker();

  return (
    <Layout
      description="Music is the future of medicine. With Brain.fm we embark on changing the world's perception of music."
      pageTitle="About us"
    >
      <AboutPageContent teamMembers={teamMembers} />
    </Layout>
  );
};

export default About;
